import Bugsnag, { User } from '@bugsnag/js';

const ERROS_TO_IGNORE = [
  'Received status code 400',
  'Failed to fetch',
]

export const reportToBugsnag = ({ error, user, caller, extraInfo }: { error: any, user?: User, caller: string, extraInfo?: { [key: string]: any } }) => {
  if (!ERROS_TO_IGNORE?.some((cur) => error?.message?.includes(cur))) {
    Bugsnag.notify(error, (event) => {
      if (user) event.setUser(user.id, user.email, user.name);
      event.addMetadata('error info', { error, caller, extraInfo });
    })
  }
}
